import { withJWTClient } from "../connectClient";

import {
  GenerateResponseSchema,
  GenerationMessageSchema,
  ListGenerationsResponseSchema,
  type CreateGenerationRequest,
  type GenerateRequest,
  type GenerationMessage,
  type ListGenerationsResponse,
} from "@/types/creativesphere";

const API_BASE_URL: string = import.meta.env.VITE_CREATIVESPHERE_API_URL || "";

/** NOTE: Must be above the server timeout so client never kills a live request. */
export const GENERATE_TIMEOUT_MS = 90_000;

export async function generate(
  req: GenerateRequest,
  signal?: AbortSignal,
): Promise<GenerationMessage> {
  const response = await withJWTClient((client) =>
    client.post<unknown>(`${API_BASE_URL}/v1/generate`, req, {
      timeout: GENERATE_TIMEOUT_MS,
      signal,
    }),
  );
  return GenerateResponseSchema.parse(response.data).generation;
}

/**
 * POST /v1/{site_id}/generations — creates a pilot generation. Returns
 * immediately in PILOT_GENERATING with a placeholder asset; the caller polls
 * {@link getGeneration} until it settles.
 */
export async function createGeneration(
  siteId: string,
  req: CreateGenerationRequest,
): Promise<GenerationMessage> {
  const response = await withJWTClient((client) =>
    client.post<unknown>(`${API_BASE_URL}/v1/${siteId}/generations`, req),
  );
  return GenerationMessageSchema.parse(response.data);
}

export async function listGenerations(
  siteId: string,
): Promise<ListGenerationsResponse> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/${siteId}/generations`),
  );
  return ListGenerationsResponseSchema.parse(response.data);
}

export async function getGeneration(
  siteId: string,
  slug: string,
): Promise<GenerationMessage> {
  const response = await withJWTClient((client) =>
    client.get<unknown>(`${API_BASE_URL}/v1/${siteId}/generations/${slug}`),
  );
  return GenerationMessageSchema.parse(response.data);
}
